import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const CDMS_STUDY_CAPTURE_STATUS_CODE: {
  CDMS_STUDY_CAPTURE_STATUS_INVALID_STATUS_REQUIREMENT: MvnCodeBE;
  CDMS_STUDY_CAPTURE_STATUS_AUDIT_REASON_MISSING: MvnCodeBE;
  CDMS_STUDY_CAPTURE_STATUS_AUDIT_REASON_EXCEED_LIMIT: MvnCodeBE;
} = {
  CDMS_STUDY_CAPTURE_STATUS_INVALID_STATUS_REQUIREMENT: {
    status: 400,
    ko: "해당 {category}에 대한 {status}을(를) 수행할 수 없습니다.",
    en: "The {status} action cannot be performed for the given {category}.",
  },
  CDMS_STUDY_CAPTURE_STATUS_AUDIT_REASON_MISSING: {
    status: 400,
    ko: "전자서명 사유 입력은 필수입니다.",
    en: "E-sign reason is mandatory.",
  },
  CDMS_STUDY_CAPTURE_STATUS_AUDIT_REASON_EXCEED_LIMIT: {
    status: 400,
    ko: "전자서명 사유는 {length}자 이내로 입력하세요.",
    en: "The length of E-sign reason exceed the limit.",
  },
};

MvnCodeInitiate(CDMS_STUDY_CAPTURE_STATUS_CODE);
